import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import ProjectBudgetForm from 'modules/project_management/components/forms/ProjectBudgetForm'
import { UpsellWizardGenericStep } from 'modules/project_management/components/upsells/UpsellWizardGenericStep'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import { CreateProjectProps } from 'modules/project_management/components/wizards/AddProjectWizard/types'

export const BudgetConfigurationStep = ({
  data,
  onDataChanged,
  hasBudgetFeature,
  hasCostsFeature,
}: WizardStepRenderParams<CreateProjectProps> & {
  hasBudgetFeature: boolean
  hasCostsFeature: boolean
}) => {
  const form = useFormContext<CreateProjectProps>()
  const handleFieldChanged = (fieldName: string, fieldValue: number | string | undefined) => {
    const newValues = { ...form.values, [fieldName]: fieldValue }
    if (fieldName === 'budgetType') {
      newValues['plannedCents'] = undefined
      newValues['feeAmountCents'] = null
      form.setErrors({ plannedCents: undefined })
    }

    onDataChanged(newValues)
  }

  const isBillable = data.isBillable
  if (!isBillable) {
    data.feeAmountCents = null
  }

  return (
    <Box flexDirection="row" gap="s48">
      <Box flexDirection="column" gap="s24" width="s400">
        <Text.Header2 weight="semibold">
          {i18n.t('project_management.modals.create_project.wizard.step_three.header')}
        </Text.Header2>
        {hasBudgetFeature ? (
          <ProjectBudgetForm
            onChangeValue={handleFieldChanged}
            values={data}
            isOwner
            isBillable={isBillable}
            errors={form.errors}
            hasBudgetFeature={hasBudgetFeature}
            hasCostsFeature={hasCostsFeature}
          />
        ) : (
          <UpsellWizardGenericStep
            featureRequested={Features.projects_budget}
            requestSource={ProjectsUpsellRequestSources.budgetStep}
          />
        )}
      </Box>
    </Box>
  )
}
